import { Button, Form, FormControl, InputGroup } from 'react-bootstrap'
import React, { useCallback } from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'
import { useLayoutStore } from '../../../state/layout.store'
import { validRegexId } from '@geartrack/shared-lib/dist/packages.model'
import usePackagesRepository from '../../../hooks/usePackagesRepository'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'

const schema = t =>
  yup.object().shape({
    id: yup
      .string()
      .required(t('trackingId.required-homepage', { ns: 'validation' }))
      .min(4, t('trackingId.min', { count: 4, ns: 'validation' }))
      .max(40, t('trackingId.max', { count: 40, ns: 'validation' }))
      .matches(validRegexId, t('trackingId.regex', { ns: 'validation' })),
  })

const TestingID = 'DY507777172PT'

const InputBar = () => {
  const pkgsRepo = usePackagesRepository()
  const isDarkMode = useLayoutStore(state => state.darkMode)
  const { t } = useTranslation('homepage')

  const savePackage = useCallback(
    id => {
      pkgsRepo.addPackage(PackageModel.create(id))
    },
    [pkgsRepo]
  )

  const manualAdd = useCallback(
    e => {
      e.preventDefault()
      savePackage(TestingID)
    },
    [savePackage]
  )

  const onSubmit = useCallback(
    values => {
      if (values.id.length === 0) return

      savePackage(values.id)
    },
    [savePackage]
  )

  return (
    <Formik initialValues={{ id: '' }} validationSchema={schema(t)} onSubmit={onSubmit}>
      {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <InputGroup hasValidation>
            <FormControl
              name="id"
              className={isDarkMode ? 'bg-dark' : 'bg-white'}
              placeholder={t('input.placeholder')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.id}
              isInvalid={!!errors.id}
            />
            <Button variant="primary" type="submit">
              {t('input.button')}
            </Button>
            <Form.Control.Feedback type="invalid">{errors.id as string}</Form.Control.Feedback>
          </InputGroup>
          <div className="text-muted mt-1" style={{ fontSize: '0.8rem' }}>
            {t('input.try')}&nbsp;
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" onClick={manualAdd}>
              {TestingID}
            </a>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default InputBar
